import { render, staticRenderFns } from "./CommentManagementInfo.vue?vue&type=template&id=6baeb8c1"
import script from "./CommentManagementInfo.vue?vue&type=script&lang=js"
export * from "./CommentManagementInfo.vue?vue&type=script&lang=js"
import style0 from "./CommentManagementInfo.vue?vue&type=style&index=0&id=6baeb8c1&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports